/* Zorina Mast — native theme helpers */
(function () {
  'use strict';

  /* ---------------------------------------------------------- countdown */
  if (!window.customElements.get('countdown-timer')) {
    class CountdownTimer extends HTMLElement {
      connectedCallback() {
        if (this._on) return;
        this._on = true;
        this.body = this.querySelector('[data-cd-body]');
        this.mode = this.dataset.mode || 'fixed';
        this.labels = (this.dataset.labels || 'dana|sati|min|sek').split('|');
        this.showLabels = this.dataset.labelsVisible !== 'false';
        this.hideDays = this.dataset.hideDays === 'true';
        this.target = this.resolve();
        this.tick();
        this.iv = setInterval(this.tick.bind(this), 1000);
      }
      disconnectedCallback() { clearInterval(this.iv); }
      now() { return Math.floor(Date.now() / 1000); }
      resolve() {
        if (this.mode !== 'evergreen') return parseInt(this.dataset.target, 10) || 0;
        var dur = parseInt(this.dataset.duration, 10) || 0;
        if (!dur) return 0;
        var key = this.dataset.storageKey, now = this.now(), start = 0;
        try { start = parseInt(localStorage.getItem(key), 10) || 0; } catch (e) {}
        var design = !!(window.Shopify && window.Shopify.designMode);
        var done = start && now >= start + dur;
        if (!start || design || (done && this.dataset.restart === 'true')) {
          start = now;
          try { localStorage.setItem(key, String(start)); } catch (e) {}
        }
        return start + dur;
      }
      tick() {
        var left = this.target - this.now();
        if (left <= 0) return this.expire();
        var d = Math.floor(left / 86400), h = Math.floor((left % 86400) / 3600),
            m = Math.floor((left % 3600) / 60), s = left % 60;
        if (this.hideDays) { h += d * 24; d = 0; }
        var units = [];
        if (d > 0) units.push([d, this.labels[0]]);
        units.push([h, this.labels[1]], [m, this.labels[2]], [s, this.labels[3]]);
        var frag = document.createDocumentFragment();
        units.forEach(function (u, i) {
          var w = document.createElement('span');
          w.className = 'zm-cd__u';
          var n = document.createElement('span');
          n.className = 'zm-cd__n';
          n.textContent = u[0] < 10 ? '0' + u[0] : String(u[0]);
          w.appendChild(n);
          if (this.showLabels && u[1]) {
            var l = document.createElement('span');
            l.className = 'zm-cd__l';
            l.textContent = u[1];
            w.appendChild(l);
          }
          frag.appendChild(w);
          if (i < units.length - 1) {
            var sep = document.createElement('span');
            sep.className = 'zm-cd__s';
            sep.textContent = ':';
            frag.appendChild(sep);
          }
        }, this);
        if (this.body) { this.body.textContent = ''; this.body.appendChild(frag); }
      }
      expire() {
        clearInterval(this.iv);
        var msg = this.dataset.expiredText || '';
        var host = this.closest('[data-cd-host]');
        var txt = host ? host.querySelector('[data-cd-text]') : null;
        if (this.dataset.onExpire === 'hide' && host) { host.hidden = true; return; }
        if (msg && txt) txt.textContent = msg;
        this.hidden = true;
      }
    }
    customElements.define('countdown-timer', CountdownTimer);
  }

  /* --------------------------------------------------- rotating messages */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-zm-rotate]').forEach(function (box) {
      var items = box.querySelectorAll('.zm-ann__msg');
      if (items.length < 2) return;
      var speed = parseInt(box.dataset.zmRotate, 10) || 5;
      var i = 0;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, speed * 1000);
    });
  });

  /* ------------------------------------------------------ bundle ladder */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-zm-bundle-input]');
    if (!input) return;
    var root = input.closest('[data-zm-bundles]');
    if (!root) return;
    root.querySelectorAll('[data-zm-offer]').forEach(function (o) {
      o.classList.toggle('is-active', o.dataset.zmOffer === input.value);
    });
  });

  /* ------------------------------------------------------ qty stepper */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-zm-qty]');
    if (!btn) return;
    e.preventDefault();
    var box = btn.closest('.zm-qty__box');
    var input = box && box.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v += btn.dataset.zmQty === 'up' ? 1 : -1;
    input.value = Math.max(1, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------- free shipping progress */
  var ShipBar = {
    nodes: [],
    threshold: 0,
    init: function () {
      this.nodes = Array.prototype.slice.call(document.querySelectorAll('[data-zm-ship]'));
      if (!this.nodes.length) return;
      this.threshold = parseInt(this.nodes[0].dataset.threshold, 10) || 0;
      this.render(parseInt(this.nodes[0].dataset.total, 10) || 0);
      this.watch();
    },
    money: function (cents) {
      var v = (cents / 100).toFixed(2).replace('.', ',');
      return '€' + v;
    },
    render: function (total) {
      var t = this.threshold;
      this.nodes.forEach(function (n) {
        var txt = n.querySelector('[data-zm-ship-txt]');
        var fill = n.querySelector('[data-zm-ship-fill]');
        if (total <= 0) { n.hidden = true; return; }
        n.hidden = false;
        var pct = Math.min(100, Math.round((total / t) * 100));
        if (fill) fill.style.width = pct + '%';
        if (!txt) return;
        if (total >= t) {
          txt.innerHTML = n.dataset.msgDone || 'Ostvarili ste <b>besplatnu dostavu</b>.';
        } else {
          var left = ShipBar.money(t - total);
          txt.innerHTML = (n.dataset.msgLeft || 'Još {amount} do besplatne dostave')
            .replace('{amount}', '<b>' + left + '</b>');
        }
      });
    },
    refresh: function () {
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { ShipBar.render(c.total_price); })
        .catch(function () {});
    },
    watch: function () {
      var of = window.fetch;
      window.fetch = function () {
        var url = arguments[0];
        var href = typeof url === 'string' ? url : (url && url.url) || '';
        var p = of.apply(this, arguments);
        if (/\/cart\/(add|change|update|clear)/.test(href)) {
          p.then(function () { setTimeout(ShipBar.refresh, 60); }).catch(function () {});
        }
        return p;
      };
      document.addEventListener('submit', function (e) {
        if (e.target && e.target.action && /\/cart/.test(e.target.action)) setTimeout(ShipBar.refresh, 400);
      });
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ShipBar.init.bind(ShipBar));
  } else {
    ShipBar.init();
  }

  /* ----------------------------------------------------------- gallery */
  document.addEventListener('click', function (e) {
    var th = e.target.closest('[data-zm-thumb]');
    if (!th) return;
    var g = th.closest('[data-zm-gallery]');
    if (!g) return;
    var main = g.querySelector('[data-zm-main] img');
    if (main) { main.src = th.dataset.full; main.srcset = th.dataset.srcset || ''; main.alt = th.dataset.alt || ''; }
    g.querySelectorAll('[data-zm-thumb]').forEach(function (t) { t.setAttribute('aria-current', String(t === th)); });
  });
})();
